import { z } from 'zod';

import { PasswordSchema } from './password.schema';

export const PasswordSignInSchema = z.object({
  email: z.string().email({ message: 'auth:errors.invalidEmail' }),
  password: PasswordSchema,
});
